
import DwellingFeaturesProperty from "@/modules/dwelling/components/sheet/DwellingFeaturesProperty.tsx";

import MapComponent from "../../../common/components/map/MapComponent";
import { IDwellingAddress } from "../../dwelling/interfaces";
import { IDwelling } from "../../dwelling/reducers";


interface IOrderPropertiesProps {
  dwelling: IDwelling;
  address: IDwellingAddress;
}

const OrderProperties: React.FC<IOrderPropertiesProps> = ({
  dwelling,
  address,
}) => {
  return (
    <div className="orderPage-properties d-flex flex-column gap-3">
      <DwellingFeaturesProperty dwelling={dwelling} extended={true} />
      <MapComponent
        coordinates={
          address.address?.latitudeY && address.address?.longitudeX
            ? {
                lat: Number(address.address?.latitudeY),
                lng: Number(address.address?.longitudeX),
              }
            : undefined
        }
        style={{
          borderRadius: "16px",
          height: "100%",
          width: "100%",
          minHeight: "250px",
        }}
      />
    </div>
  );
};

export default OrderProperties;
